module.exports = __webpack_public_path__ + "img/lobby_hosting_afk.493a27a5.png";